var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
const VariantToElementMap = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    p: 'p',
    caption: 'span',
    meta: 'span',
};
const Typography = (_a) => {
    var { children, element, variant = 'p', className } = _a, props = __rest(_a, ["children", "element", "variant", "className"]);
    const Element = element !== null && element !== void 0 ? element : VariantToElementMap[variant];
    return (_jsx(Element, Object.assign({}, props, { className: [
            'c-typography',
            `c-typography__variant--${variant}`,
            ...className ? [className] : [],
        ].join(' ') }, { children: children })));
};
export { Typography, };
